module.exports = __webpack_public_path__ + "img/720.9b2aecb4.svg";